import { Component, Injector } from '@angular/core';
import { routes as routesCatalog, formats as formatsCatalog } from 'src/app/utils/catalog';
import { SubscriptionHandlerComponent } from 'src/app/components/misc/subscription-handler/subscription-handler.component';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { StorageService } from 'src/app/services/storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  template: '',
})
export class BasePageComponent extends SubscriptionHandlerComponent {
  public routes = routesCatalog;
  public formats = formatsCatalog;

  public pageLoading: boolean;

  protected router: Router;
  protected authService: AuthService;
  protected storageService: StorageService;
  protected translator: TranslateService;

  constructor(protected injector: Injector) {
    super();

    this.router = injector.get(Router);
    this.authService = injector.get(AuthService);
    this.storageService = injector.get(StorageService);
    this.translator = injector.get(TranslateService);

    this.pageLoading = false;
  }

  protected startLoading() {
    this.pageLoading = true;
  }

  protected stopLoading() {
    this.pageLoading = false;
  }
}
